// Registers the service worker that keeps the app shell on the phone, so
// the app opens offline once installed (SPEC-12, question 1). The worker
// itself is generated at build time by scripts/pwa.ts.

export function registerServiceWorker() {
  // The dev server has no worker: it would cache files that change on
  // every save.
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error: unknown) => {
      console.error("[pwa] service worker registration failed", error);
    });
  });
}
